export const SET_MEMBERS = `SET_MEMBERS`; 
export const SET_MEMBERCOUNT = `SET_MEMBERCOUNT`; 
export const SET_MEMBERGROUPS = `SET_MEMBERGROUPS`;
export const SET_MEMBERSLIST = `SET_MEMBERSLIST`;
export const SET_CONFIG = `SET_CONFIG`;
export const SET_CONTACT_PERSON = `SET_CONTACT_PERSON`;
export const SET_MEMBERGROUP = `SET_MEMBERGROUP`
export const SET_BANKDATA = `SET_BANKDATA`

// events
export const SET_EVENTS = `SET_EVENTS`
export const SET_EVENT_DETAILS = `SET_EVENT_DETAILS`

// participants
export const SET_PARTICIPANTS = `SET_PARTICIPANTS`
export const SET_PARTICIPANTS_REQUESTED_EVENT = `SET_PARTICIPANTS_REQUESTED_EVENT`
export const SET_PARTICIPANT = `SET_PARTICIPANT`

// persons
export const SET_PERSONS = `SET_PERSONS`

// member type correction
export const SET_MEMBER_TYPE_CORRECTION_RUN = `SET_MEMBER_TYPE_CORRECTION_RUN`
export const SET_MEMBER_TYPE_CORRECTION_PREVIEW = `SET_MEMBER_TYPE_CORRECTION_PREVIEW`
export const SET_MEMBER_TYPE_CORRECTION_CANDIDATE_SELECTION = `SET_MEMBER_TYPE_CORRECTION_CANDIDATE_SELECTION`
export const SET_MEMBER_TYPE_CORRECTION_LOADING = `SET_MEMBER_TYPE_CORRECTION_LOADING`
export const SET_MEMBER_TYPE_CORRECTION_ERROR = `SET_MEMBER_TYPE_CORRECTION_ERROR`
export const SET_MEMBER_TYPE_CORRECTION_APPLY_RESULT = `SET_MEMBER_TYPE_CORRECTION_APPLY_RESULT`
export const SET_MEMBER_TYPE_CORRECTION_SUMMARY = `SET_MEMBER_TYPE_CORRECTION_SUMMARY`
export const SET_MEMBER_TYPE_CORRECTION_BILLING_LOADING = `SET_MEMBER_TYPE_CORRECTION_BILLING_LOADING`
export const SET_MEMBER_TYPE_CORRECTION_BILLING_ERROR = `SET_MEMBER_TYPE_CORRECTION_BILLING_ERROR`
export const SET_MEMBER_TYPE_CORRECTION_BILLING_CREATED = `SET_MEMBER_TYPE_CORRECTION_BILLING_CREATED`
export const RESET_MEMBER_TYPE_CORRECTION_STATE = `RESET_MEMBER_TYPE_CORRECTION_STATE`
